export const localTimezone = {
  computed: {
    localTimeZone() {
      return Intl.DateTimeFormat().resolvedOptions().timeZone.replace(/_/g, ' ')
    },
  },
}
